import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CategoryCard({ category }) {
  return (
    <Link
      to={`/categories/${category.slug}`}
      className="group block bg-surface border border-neutral-200 rounded-xl p-7 hover:border-indigo-300 hover:bg-indigo-50/40 transition-colors duration-300"
      data-testid={`category-card-${category.slug}`}
    >
      <div className="flex items-start justify-between mb-4">
        <span className="eyebrow">Category</span>
        <ArrowRight
          size={16}
          className="text-neutral-400 group-hover:text-indigo-800 group-hover:translate-x-0.5 transition-[transform,color]"
        />
      </div>
      <h3 className="font-playfair text-2xl text-neutral-900 mb-3 group-hover:text-indigo-900 transition-colors">
        {category.name}
      </h3>
      <p className="text-sm text-neutral-600 leading-relaxed">
        {category.intro}
      </p>
    </Link>
  );
}
